import { render, staticRenderFns } from "./Simulation2.vue?vue&type=template&id=604f6adc&scoped=true"
import script from "./Simulation2.vue?vue&type=script&lang=js"
export * from "./Simulation2.vue?vue&type=script&lang=js"
import style0 from "./Simulation2.vue?vue&type=style&index=0&id=604f6adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604f6adc",
  null
  
)

export default component.exports